export const barChartData = [
  { country: "South Korea", value: 380 },
  { country: "Canada", value: 430 },
  { country: "United Kingdom", value: 450 },

];


export const lineChartData ={
    line_graph_json: {
    config: {
      view: {
        "continuousWidth": 300,
        "continuousHeight": 300
      }
    },
    data: {
      name: "data-932215df8dce15597dc8bc596152d541"
    },
    mark: {
      type: "line",
      color: "BrandCode"
    },
    encoding: {
      tooltip: [
        {
          "field": "BrandCode",
          "type": "nominal"
        },
        {
          "field": "MaxDebitValue",
          "type": "quantitative"
        }
      ],
      x: {
        field: "BrandCode",
        type: "ordinal"
      },
      y: {
        field: "MaxDebitValue",
        type: "quantitative"
      }
    },
    params: [
      {
        name: "param_1",
        select: {
          type: "interval",
          encodings: [
            "x",
            "y"
          ]
        },
        bind: "scales"
      }
    ],
    title: "MaxDebitValue by BrandCode",
    $schema: "https://vega.github.io/schema/vega-lite/v5.20.1.json",
    datasets: {
      "data-932215df8dce15597dc8bc596152d541": [
        {
          "BrandCode": "IM",
          "MaxDebitValue": 323242.5
        },
        {
          "BrandCode": "CF",
          "MaxDebitValue": 261569.48
        },
        {
          "BrandCode": "UR",
          "MaxDebitValue": 98159.9
        },
        {
          "BrandCode": "CT",
          "MaxDebitValue": 50094
        },
        {
          "BrandCode": "MC",
          "MaxDebitValue": 36817.7
        },
        {
          "BrandCode": "MB",
          "MaxDebitValue": 29511.8
        },
        {
          "BrandCode": "HP",
          "MaxDebitValue": 23744.95
        },
        {
          "BrandCode": "TY",
          "MaxDebitValue": 20968.7
        },
        {
          "BrandCode": "MM",
          "MaxDebitValue": 20073.3
        },
        {
          "BrandCode": "MZ",
          "MaxDebitValue": 18325.1
        },
        {
          "BrandCode": "DA",
          "MaxDebitValue": 9259.9
        },
        {
          "BrandCode": "LF",
          "MaxDebitValue": 8218.6
        },
        {
          "BrandCode": "RU",
          "MaxDebitValue": 6979.6
        },
        {
          "BrandCode": "SB",
          "MaxDebitValue": 661.5
        }
      ]
    }
  }
};


export const pieChartData ={
   pie_chart_json:{
   config:{
      "view":{
         "continuousWidth":300,
         "continuousHeight":300
      }
   },
   data:{
      name:"data-766ddd191a70d2cab2327dce2dc42e90"
   },
   mark:{
      type:"arc"
   },
   encoding:{
      color:{
         field:"BrandCode",
         type:"nominal"
      },
      theta:{
         field:"total_balance",
         type:"quantitative"
      },
      tooltip:[
         {
            "field":"BrandCode",
            "type":"nominal"
         },
         {
            "field":"total_balance",
            "type":"quantitative"
         }
      ]
   },
   title:"total_balance by BrandCode",
   $schema:"https://vega.github.io/schema/vega-lite/v5.20.1.json",
   datasets:{
      "data-766ddd191a70d2cab2327dce2dc42e90":[
         {
            "BrandCode":"CF",
            "total_balance":218484291694.8914
         },
         {
            "BrandCode":"CT",
            "total_balance":77624884191.41252
         },
         {
            "BrandCode":"DA",
            "total_balance":21200704576.869995
         },
         {
            "BrandCode":"HP",
            "total_balance":805142129625.2107
         },
         {
            "BrandCode":"IM",
            "total_balance":967369753188.5087
         },
         {
            "BrandCode":"LF",
            "total_balance":115215908547.39813
         },
         {
            "BrandCode":"MB",
            "total_balance":60422726172.09996
         },
         {
            "BrandCode":"MC",
            "total_balance":797804595429.7368
         },
         {
            "BrandCode":"MM",
            "total_balance":236763580042.0164
         },
         {
            "BrandCode":"MZ",
            "total_balance":30737710235.709595
         },
         {
            "BrandCode":"RU",
            "total_balance":90894054403.88011
         },
         {
            "BrandCode":"SB",
            "total_balance":27396689551.869953
         },
         {
            "BrandCode":"TY",
            "total_balance":168878247174.04227
         },
         {
            "BrandCode":"UR",
            "total_balance":2771791930.2999983
         }
      ]
   }
}

};

//table chart
export const tableChartData = {
  table_result: [
    { BrandCode: "CF", total_balance: 218484291694.8914 },
    { BrandCode: "CT", total_balance: 77624884191.41252 },
    { BrandCode: "DA", total_balance: 21200704576.869995 },
    { BrandCode: "HP", total_balance: 805142129625.2107 },
    { BrandCode: "IM", total_balance: 967369753188.5087 },
    { BrandCode: "LF", total_balance: 115215908547.39813 },
    { BrandCode: "MB", total_balance: 60422726172.09996 },
    { BrandCode: "MC", total_balance: 797804595429.7368 },
    { BrandCode: "MM", total_balance: 236763580042.0164 },
    { BrandCode: "MZ", total_balance: 30737710235.709595 },
    { BrandCode: "RU", total_balance: 90894054403.88011 },
    { BrandCode: "SB", total_balance: 27396689551.869953 },
    { BrandCode: "TY", total_balance: 168878247174.04227 },
    { BrandCode: "UR", total_balance: 2771791930.2999983 }
  ]
};

// bar chart column
export const columnBarChart_data = [
  {
    name: "Actual",
    data: [
      { x: "2011", y: 12, goals: [{ name: "Expected", value: 14, strokeWidth: 5, strokeColor: "#564ab1" }] },
      { x: "2012", y: 44, goals: [{ name: "Expected", value: 54, strokeWidth: 5, strokeColor: "#564ab1" }] },
      { x: "2013", y: 54, goals: [{ name: "Expected", value: 52, strokeWidth: 5, strokeColor: "#564ab1" }] },
      { x: "2014", y: 66, goals: [{ name: "Expected", value: 65, strokeWidth: 5, strokeColor: "#564ab1" }] },
      { x: "2015", y: 81, goals: [{ name: "Expected", value: 66, strokeWidth: 5, strokeColor: "#564ab1" }] },
      { x: "2016", y: 67, goals: [{ name: "Expected", value: 70, strokeWidth: 5, strokeColor: "#564ab1" }] },
    ],
  },
];


//bar chart stacked
export const barChartStacked_data = [
  {
    name: 'Marine Sprite',
    data: [44, 55, 41, 37, 22, 43, 21]
  },
  {
    name: 'Striking Calf',
    data: [53, 32, 33, 52, 13, 43, 32]
  },
  {
    name: 'Tank Picture',
    data: [12, 17, 11, 9, 15, 11, 20]
  },
  {
    name: 'Bucket Slope',
    data: [9, 7, 5, 8, 6, 9, 4]
  },
  {
    name: 'Reborn Kid',
    data: [25, 12, 19, 32, 25, 24, 10]
  }
];

//apex pie chart
export const apex_pie_my_Data = [
  { label: "Team A", value: 44 },
  { label: "Team B", value: 55 },
  { label: "Team C", value: 13 },
  { label: "Team D", value: 43 },
  { label: "Team E", value: 22 },
];



// apex line chart
export const apex_line_chart_data ={
  line_json: {
    data: { name: 'data-line-id' },
    datasets: {
      'data-line-id': [
        { month: 'Jan', value: 10 },
        { month: 'Feb', value: 41 },
        { month: 'Mar', value: 35 },
        { month: 'Apr', value: 51 },
        { month: 'May', value: 49 },
        { month: 'Jun', value: 62 },
        { month: 'Jul', value: 69 },
        { month: 'Aug', value: 91 },
        { month: 'Sep', value: 148 }
      ]
    }
  }
};


//multi axis line chart
export const multiAxisLineChart = {
  series: [
    {
      name: "Temperature",
      type: "line",
      data: [30, 40, 35, 50, 49, 60, 70]
    },
    {
      name: "Rainfall",
      type: "line",
      data: [20, 29, 37, 36, 44, 45, 50]
    }
  ],
  options: {
    chart: {
      type: 'line',
      toolbar: {
        show: true,
      }
    },
    stroke: {
      width: [3, 3],
      curve: 'smooth'
    },
    colors: ['#FF1654', '#247BA0'],
    dataLabels: {
      enabled: false
    },
    markers: {
      size: 5
    },
    xaxis: {
      categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    },
    yaxis: [
      {
        title: {
          text: "Temperature (°C)",
        },
        labels: {
          style: {
            color: '#FF1654'
          }
        }
      },
      {
        opposite: true,
        title: {
          text: "Rainfall (mm)",
        },
        labels: {
          style: {
            color: '#247BA0'
          }
        }
      }
    ],
    tooltip: {
      shared: true,
      intersect: false,
    },
    legend: {
      position: 'top',
      horizontalAlign: 'left',
      offsetX: 10
    }
  }
};


// mockData.js

const seriesData = {
  monthDataSeries1: {
    prices: [8100, 8120, 8200, 8250, 8300, 8290, 8270],
    dates: [
      "2023-01-01", "2023-01-02", "2023-01-03",
      "2023-01-04", "2023-01-05", "2023-01-06", "2023-01-07"
    ]
  }
};

// area chart
export const areaChart = {
  series: [
    {
      name: "STOCK ABC",
      data: seriesData.monthDataSeries1.prices
    }
  ],
  options: {
    chart: {
      type: 'area',
      height: 350,
      zoom: {
        enabled: false
      }
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: 'straight'
    },
    title: {
      text: 'Fundamental Analysis of Stocks',
      align: 'left',
      style: {
        fontWeight: 500,
      },
    },
    subtitle: {
      text: 'Price Movements',
      align: 'left'
    },
    labels: seriesData.monthDataSeries1.dates,
    xaxis: {
      type: 'datetime',
    },
    yaxis: {
      opposite: true
    },
    legend: {
      horizontalAlign: 'left'
    },
    responsive: [
      {
        breakpoint: 768,
        options: {
          chart: {
            height: 300
          },
          title: {
            style: {
              fontSize: '14px'
            }
          },
          subtitle: {
            style: {
              fontSize: '12px'
            }
          }
        }
      },
      {
        breakpoint: 480,
        options: {
          chart: {
            height: 250
          },
          xaxis: {
            labels: {
              show: false
            }
          },
          legend: {
            show: false
          }
        }
      }
    ]
  }
};

//range bar chart
export const rangeBarChart = {
  series: [
    {
      name: "Bob",
      data: [
        {
          x: "Design",
          y: [
            new Date("2019-03-05").getTime(),
            new Date("2019-03-08").getTime(),
          ],
        },
        {
          x: "Code",
          y: [
            new Date("2019-03-08").getTime(),
            new Date("2019-03-11").getTime(),
          ],
        },
        {
          x: "Test",
          y: [
            new Date("2019-03-11").getTime(),
            new Date("2019-03-16").getTime(),
          ],
        },
      ],
    },
    {
      name: "Joe",
      data: [
        {
          x: "Design",
          y: [
            new Date("2019-03-02").getTime(),
            new Date("2019-03-05").getTime(),
          ],
        },
        {
          x: "Code",
          y: [
            new Date("2019-03-06").getTime(),
            new Date("2019-03-09").getTime(),
          ],
        },
        {
          x: "Test",
          y: [
            new Date("2019-03-10").getTime(),
            new Date("2019-03-19").getTime(),
          ],
        },
      ],
    },
  ]
};

function generateData(count, yrange) {
  let series = [];
  for (let i = 0; i < count; i++) {
    const x = (i + 1).toString();
    const y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;

    series.push({ x, y });
  }
  return series;
}

// Exporting heatBarChart with a series array
export const heatBarChart = {
  series: [
    { name: 'Metric1', data: generateData(18, { min: 0, max: 90 }) },
    { name: 'Metric2', data: generateData(18, { min: 0, max: 90 }) },
    { name: 'Metric3', data: generateData(18, { min: 0, max: 90 }) },
    { name: 'Metric4', data: generateData(18, { min: 0, max: 90 }) },
    { name: 'Metric5', data: generateData(18, { min: 0, max: 90 }) },
    { name: 'Metric6', data: generateData(18, { min: 0, max: 90 }) },
    { name: 'Metric7', data: generateData(18, { min: 0, max: 90 }) },
    { name: 'Metric8', data: generateData(18, { min: 0, max: 90 }) },
    { name: 'Metric9', data: generateData(18, { min: 0, max: 90 }) },
  ],
};


// Donut chart mock data
export const donutChartData = {
  series: [44, 33, 22, 11],
  labels: ['Apples', 'Bananas', 'Cherries', 'Grapes'],
};


// Line + Bar chart mock data
export const lineBarChartData = {
  labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
  series: [
    {
      name: "Sales",
      type: "column",
      data: [23, 34, 45, 56, 67, 78, 89],
    },
    {
      name: "Growth",
      type: "line",
      data: [10, 20, 15, 30, 25, 35, 40],
    },
  ],
};


// Utility function to generate random scatter points
const generateScatterData = (count, yrange) => {
  const series = [];
  for (let i = 0; i < count; i++) {
    const x = Math.floor(Math.random() * (750 - 1 + 1)) + 1;
    const y =
      Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
    series.push([x, y]);
  }
  return series;
};

// Scatter chart mock data
export const scatterChartData = {
  series: [
    {
      name: "Sample A",
      data: generateScatterData(20, { min: 10, max: 60 }),
    },
    {
      name: "Sample B",
      data: generateScatterData(20, { min: 10, max: 60 }),
    },
    {
      name: "Sample C",
      data: generateScatterData(20, { min: 10, max: 60 }),
    },
  ],
};


//horizontal bar chart
export const Horizontal_barChartData = {
  categories: [
    "South Korea",
    "Canada",
    "United Kingdom",
    "Netherlands",
    "Italy",
    "France",
    "Japan",
    "United States",
    "China",
    "Germany",
  ],
  series: [400, 430, 448, 470, 540, 580, 690, 1100, 1200, 1380],
};

// zoomable line chart mock data




const generateDataTimeSeries = (startDate, count) => {
    const data = [];
    let date = new Date(startDate);

    for (let i = 0; i < count; i++) {
        data.push([
        date.getTime(),
        Math.floor(Math.random() * (90 - 20 + 1)) + 20, // random between 20–90
        ]);
        date.setDate(date.getDate() + 1);
    }
    return data;
    };

export const StockAreaChartData = {
  series: [
    {
      name: "XYZ MOTORS",
      data: generateDataTimeSeries("2023-01-01", 120), // 120 days
    },
  ],
  options: {
    chart: {
      type: "area",
      stacked: false,
      height: 350,
      zoom: {
        type: "x",
        enabled: true,
        autoScaleYaxis: true,
      },
      toolbar: {
        autoSelected: "zoom",
      },
    },
    dataLabels: { enabled: false },
    markers: { size: 0 },
    title: {
      text: "Stock Price Movement",
      align: "left",
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        inverseColors: false,
        opacityFrom: 0.5,
        opacityTo: 0,
        stops: [0, 90, 100],
      },
    },
    yaxis: {
      labels: {
        formatter: (val) => (val / 1000000).toFixed(0),
      },
      title: { text: "Price" },
    },
    xaxis: {
      type: "datetime",
    },
    tooltip: {
      shared: false,
      y: {
        formatter: (val) => (val / 1000000).toFixed(0),
      },
    },
  },
};